import { createContext } from 'react';

import { FormatterWithPrecision } from '../../core/types/formatter.js';

export const CategoricalBarChartValueFormatter = createContext<
  FormatterWithPrecision | undefined
>(undefined);

CategoricalBarChartValueFormatter['displayName'] =
  'CategoricalBarChartValueFormatter';
